<template>
  <div>
    <router-link
      v-if="isChatEnabled"
      :to="{ name: 'PersonalSupportChat', query: { chatRoomId: `rue-jai-app-user-${id}` } }"
      v-slot="{ navigate }"
      custom
    >
      <button
        @click="navigate"
        title="แชทกับลูกบ้าน"
        type="button"
        class="chat-button"
      >
        <img src="/static/icons/personal-chat.svg" alt="Chat" class="chat-icon" />
      </button>
    </router-link>
    <button v-else title="ไม่รองรับการแชท" class="chat-button" disabled>
      <img src="/static/icons/personal-chat.svg" alt="Chat" class="chat-icon" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isSupportRueJaiChat: { type: Boolean, default: false },
    id: { type: [String, Number], default: null },
  },
  computed: {
    isChatEnabled() {
      return this.isSupportRueJaiChat && this.id !== null && this.id !== ""
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-button {
  background: none;
  border: solid 1px grey;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.chat-icon {
  width: 22px;
  height: 22px;
  display: block;
}
</style>
